<template>
 <div class="my-account-menu-nav">
   <!-- router link creating refresh issue on route move, so tried with push on uat so has to do like this -->
  <ul>
    <li>
      <a @click.prevent="movetoEditAccount()" :class="'is-size-14 font-color has-text-weight-semibold ' +  ( $route.name == 'UserEditAccount' ? 'router-link-active' : '')">GENERAL</a>
    </li>
    <li>
      <a @click.prevent="movetoMembership()" :class="'is-size-14 font-color has-text-weight-semibold ' +   ( $route.name == 'UserAccountMembership' ? 'router-link-active' : '')">MEMBERSHIP</a>
    </li>
  </ul>
</div>
</template>


<script>
export default {
  methods: {
    movetoMembership() {
      this.$router.push({
        name: 'UserAccountMembership',
        business_slug: this.$route.params.business_slug,
        query: this.$route.query
      })
    },
    movetoEditAccount() {
      this.$router.push({
        name: 'UserEditAccount',
        business_slug: this.$route.params.business_slug,
        query: this.$route.query
      })
    }
  },
}
</script>